import * as actionsType from '../actions/actionsType';

const initialState = {
    loading: false,
    booked: false,
    error: null,
};

export const bookReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionsType.BOOK_START:
            return {
                ...state,
                loading: true,
                error: null,
                booked: false,
            };
        case actionsType.BOOK_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                booked: true,
            };
        case actionsType.BOOK_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                booked: false,
            }
        default:
            return {
                ...state,
            };
    }
};

export default bookReducer;